<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="content" v-else>
            <div class="row">
                <div class="col-12">
                    <div class="main-title">
                        <h2>Pay Period {{ dateForTimeSheets(start_date) }} - {{ dateForTimeSheets(end_date) }}</h2>
                        <a href="/master-admin/timesheets" class="back-link">
                            <img src="/img/svg/icons-arrow-left.svg" alt="">
                            Back
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 mb-4">
                    <div class="box">
                        <div class="box-offset">
                            <div class="box-ttl">Total Timesheets Submitted {{ timesheets.length }}</div>
                            <div class="buttons--row mt-2 mb-4">
                                <div class="filter-wrap">
                                    <label for="" class="reg-label mr-2">Filter:</label>
                                    <div class="form-group form-group-2 mb-0">
                                        <select
                                            class="custom-select"
                                            @change="getListOfTimesheets"
                                            v-model="filters.status"
                                        >
                                            <option value="all" selected="">Select One</option>
                                            <option value="new">New</option>
                                            <option value="approved">Approved</option>
                                            <option value="needs-attention">Needs Attention</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="search--block">
                                    <button
                                        class="search--block-btn"
                                        type="submit"
                                        @click="getListOfTimesheets"
                                    ><img src="/img/svg/icons-search.svg" alt="">
                                    </button>
                                    <input
                                        type="search"
                                        class="search--block-txt"
                                        placeholder="Search"
                                        v-model="filters.search"
                                        @input="handleSearch"
                                    />
                                </div>
                                <a :href="`/master-admin/timesheets/periods/${periodId}/timesheets/custom`"
                                   class="btn btn--outline-primary btn--middle w-xs-100">
                                    + Add Custom Timesheet
                                </a>
                                <button class="btn btn--outline-primary btn--middle w-xs-100"
                                        @click="showCustomModal('file', 1)">
                                    + Add Attachment/PDF
                                </button>

                                <TimesheetAttachmentsModal
                                    :id="getCustomModalId('file', 1)"
                                    :applicants="applicants"
                                    :period-id="periodId"
                                    @confirm="uploadApplicantFile"
                                >
                                </TimesheetAttachmentsModal>

                                <a
                                    target="_blank"
                                    :href="`/master-admin/timesheets/periods/${periodId}/export`"
                                    class="btn btn--outline-primary btn--middle w-xs-50"
                                    v-if="possibilityToExport"
                                >
                                    Export
                                </a>
                                <a
                                   :href="`/master-admin/timesheets/print?timesheetsIds[]=${timesheetsIds}`"
                                   target="_blank"
                                   class="btn btn--outline-primary btn--middle w-xs-50"
                                >
                                    Print
                                </a>
                            </div>
                            <div class="table-holder table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Date Submitted</th>
                                        <th class="text-center">Notes</th>
                                        <th class="text-center">Training</th>
                                        <th class="text-center">Regular</th>
                                        <th class="text-center">OT</th>
                                        <th class="text-center">Total Hours Claimed</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="item in timesheets"
                                        :key="item.id"
                                    >
                                        <td class="color--text">
                                            <a :href="`/master-admin/applicants/${item.applicant_id}/show?type=submitted`">
                                                <b>{{ item.applicant.name }} {{ item.applicant.last_name }}</b>
                                            </a>
                                        </td>
                                        <td>
                                            {{ item.date_submitted ?? calculateDate(item.created_at) }}
                                        </td>
                                        <td
                                            v-if="item.file_id"
                                            class="text-center"
                                        >
                                            attached file
                                            <a :href="`/uploads/${item.file.file_path}`"
                                               class="color--secondary"
                                               title="View"
                                               target="_blank"
                                               v-if="item.file_id"
                                            ><i class="fas fa-eye"></i>
                                            </a>
                                        </td>
                                        <td
                                            v-else
                                            class="text-center"
                                            @click="redirectToTimesheet(item)"
                                        >{{ item.comment }}
                                        </td>
                                        <td class="text-center"
                                            @click="redirectToTimesheet(item)"
                                        >{{item.trainings.length > 0? 'Yes' : 'No'}}
                                        </td>

                                        <td
                                            class="text-center"
                                            @click="redirectToTimesheet(item)"
                                        >
                                            {{ formatTime(item.regular) ?? '' }}
                                        </td>
                                        <td
                                            class="text-center"
                                            @click="redirectToTimesheet(item)"
                                        >
                                            {{ formatTime(item.overtime) ?? '' }}
                                        </td>
                                        <td
                                            class="text-center"
                                            @click="redirectToTimesheet(item)">
                                            <b>{{formatTime(item.regular + item.overtime) }}</b>
                                        </td>
                                        <td>
                                            <div class="form-group form-group-1 mb-1">
                                                <select
                                                    :style="{ color: selectColor(item.status)}"
                                                    v-model="item.status"
                                                    @change="changeTimesheetStatus(item.id, item.status)"
                                                    class="custom-select custom-select-wb change_color"
                                                >
                                                    <option value="">Select One</option>
                                                    <option value="approved">Approved</option>
                                                    <option value="new">New</option>
                                                    <option value="needs-attention">Needs Attention</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                :currentPage="pagination.current_page"
                                :lastPage="pagination.last_page"
                                @changeItemsPerPage="changeItemsPerPage"
                                @changePage="changePage"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import TimeSheetService from "./services/TimeSheetService";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import TimesheetAttachmentsModal from "./TimesheetAttachmentsModal.vue";
import AddNewFileModal from "../../../../../resources/js/components/AddNewFileModal.vue";
import ExportHandler from "../../../../../resources/js/mixins/ExportHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'ListOfTimesheets',
    props: {
        possibilityToExport: {
            type: Boolean,
            required: true
        } ,
        applicants:{
           type: Array,
           required: true
        },

    },
    components: {AddNewFileModal, TimesheetAttachmentsModal, Pagination},
    mixins: [
        ModalHandler,
        PaginationHandler,
        DateConverter,
        StyleHandler,
        ExportHandler,
    ],
    data() {
        return {
            loading: true,
            start_date: null,
            end_date: null,
            timesheets: [],
            periodId: null,
            timesheetsIds: [],
            filters: {
                status: 'all',
                search: '',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        async changeTimesheetStatus(id, status) {
            this.$showLoadingMessage()
            try {
                await TimeSheetService.updateTimesheetStatus(this.periodId, id, status)
                this.$showSuccessMessage('Status has been changed')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Status was not changed. Please try again.')
            }
        },
        getList(filters) {
            this.getListOfTimesheets(filters)
        },
        getPeriodId() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has('period')) {
                this.periodId = urlParams.get('period');
            }
        },
        async getListOfTimesheets() {
            try {
                const {data: response} = await TimeSheetService.getTimesheets(this.periodId, this.filters)
                if (response.list) {
                    this.timesheets = response.list.data
                    this.pagination.current_page = response.list.current_page
                    this.pagination.last_page = response.list.last_page
                    this.timesheetsIds = this.timesheets.map(t => t.id)
                }
                this.start_date = response.period.start_date
                this.end_date = response.period.end_date
                this.loading = false
            } catch {
            }
        },
        redirectToTimesheet(item) {
            if (item.file_id) {
                return
            } else {
                window.location.href = `/master-admin/timesheets/periods/${this.periodId}/timesheets/${item.id}/show`
            }
        },
        async uploadApplicantFile(payload) {
            this.$showLoadingMessage()
            try {
                await TimeSheetService.storeTimesheetFile(this.periodId, payload)
                this.$showSuccessMessage('File was uploaded')
                await this.getListOfTimesheets()
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your file was not uploaded. Please try again')
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getPeriodId()
        this.getListOfTimesheets()
        this.delayedSearch = createDebouncedFunction(() => this.getListOfTimesheets(), 500);
    },


}

</script>

<style scoped>

</style>
